import React from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const CaatNav = (props) => {
  const location = useLocation();
  const isRegulatorPage = location.pathname === "/regulator/regulatordrone";
  const isCaatoperationstatusPage =
    location.pathname === "/regulator/caatoperationstatus" ||
    location.pathname === "/regulator/regulatordronemonitoring"
    
  const isCaatpilot =
    location.pathname === "/regulator/caatpilotapproval";
    

  const regulatorStyle = isRegulatorPage
    ? { textDecoration: "underline  5px", textUnderlineOffset: "8px" }
    : { textDecoration: "none" };
  const caatOperationStatusStyle = isCaatoperationstatusPage
    ? { textDecoration: "underline  5px", textUnderlineOffset: "8px" }
    : { textDecoration: "none" };
const caatpilotStyle = isCaatpilot
    ? { textDecoration: "underline  5px", textUnderlineOffset: "8px" }
    : { textDecoration: "none" };

  return (
    <Nav
      className="navbar navbar-expand navbar-dark"
      style={{
        width: "100% !important",
        //top: "0px",
        height: "6.75vh",
        padding: "0.5rem 0.5rem",
        position: "relative",
        borderBottom: "1px solid",
        borderBottomColor: "#b1bcc4b5",
        background: "#FFFFFF",
        boxShadow:
          "inset 2px 2px 2px 0px rgba(255, 255, 255, .5), 7px 7px 20px 0px rgba(0, 0, 0, .1), 4px 4px 5px 0px rgba(0, 0, 0, .1)",
        //width:"100%"Drone
      }}
    >
      <Link to={"/home"} className=" logo-text">
        <img
          src={props.logo_dronewhite}
          alt="profile-img"
          style={{
            margin: "10px",
            height: "60px",
          }}
        />
      </Link>
      <div className="navbar-nav" style={{ marginBottom: "10px" }}>
        <NavDropdown
          className="nav-dropdown"
          title={
            <div
              style={{
                color: "#6D7073",
                //position: "absolute",
              }}
            >
              <li className="nav-item" style={regulatorStyle}>
                Drone
              </li>{" "}
            </div>
          }
          style={{
            color: "#6D7073",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "32px",
            textAlign: "center",
          }}
        >
          <NavDropdown.Item eventKey="4.1" href="/regulator/regulatordrone">
            สถานะการขอขึ้นทะเบียน
          </NavDropdown.Item>
        </NavDropdown>

        {props.isCaat ? (
          null
        ) : (
          <div className="navbar-nav ">
            <NavDropdown
              title={
                <div
                  className="navbar-nav ml-auto"
                  style={{
                    color: "#6D7073",
                    //position: "absolute",
                  }}
                >
                  <li className="nav-item" style={caatpilotStyle}>
                 Pilot
                  </li>{" "}
                </div>
              }
              className="nav-dropdown"
              style={{
                color: "#EDEDED",
                fontFamily: "Montserrat",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "32px",

                top: "0px",
              }}
            >
              <NavDropdown.Item
                eventKey="4.1"
                href="/regulator/caatpilotapproval"
              >
                สถานะการขอขึ้นทะเบียนนักบิน
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={
                <div
                  className="navbar-nav ml-auto"
                  style={{
                    color: "#6D7073",
                    //position: "absolute",
                  }}
                >
                  <li className="nav-item" style={caatOperationStatusStyle}>
                    Operation
                  </li>{" "}
                </div>
              }
              className="nav-dropdown"
              style={{
                color: "#EDEDED",
                fontFamily: "Montserrat",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "32px",

                top: "0px",
              }}
            >
              <NavDropdown.Item
                eventKey="4.1"
                href="/regulator/caatoperationstatus"
              >
                รายการปฏิบัติการทั้งหมด
              </NavDropdown.Item>
              <NavDropdown.Item
                eventKey="4.2"
                href="/regulator/regulatordronemonitoring"
              >
                Monitoring
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        )}
      </div>
      {props.currentUser ? (
        <div className="navbar-nav ml-auto">
          <NavDropdown
            title={
              <div style={{ display: "flex" }}>
                <div
                  className="navbar-nav ml-auto"
                  style={{
                    color: "#6D7073",
                    right: "30%",
                    //position: "absolute",
                    //top: "-5px",
                    fontSize: "26px",
                    lineHeight: "32px",
                    fontWeight: "400",
                    fontStyle: "normal",
                  }}
                >
                  <li className="nav-item activenav">
                    {props.currentUser.f_name.substring(0, 8)}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </li>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ left: "100%" }}>
                    <div
                      className="navbar-nav ml-auto"
                      style={{
                        position: "absolute",
                        top: "10%",
                        //left: "6%",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#023E8A",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "26px",
                        color: "white",
                        borderRadius: "50%",
                      }}
                    >
                      {props.currentUser.f_name.charAt(0)}
                    </div>
                  </div>
                </div>
              </div>
            }
            className="nav-dropdown"
            style={{
              color: "#EDEDED",
              fontFamily: "Kanit",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "34px",

              right: "25%",
              width: "100%",
            }}
          >
            <NavDropdown.Item eventKey="4.1" onClick={() => props.logOut()}>
              ออกจากระบบ
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      ) : (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link
              to={"/login"}
              className="nav-link"
              style={{ color: "#6D7073" }}
            >
              Login
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to={"/register"}
              className="nav-link"
              style={{ color: "#6D7073" }}
            >
              Sign Up
            </Link>
          </li>
        </div>
      )}
    </Nav>
  );
};

export default CaatNav;
